import { mkFreeToSpend } from './freeToSpendTypes';
import type { FreeToSpend } from './freeToSpendTypes';

export function transformResponseToFreeToSpend(response: any) {
  return response?.data?.resources?.map((fts: FreeToSpend) => mkFreeToSpend(fts));
}

export function transformRequestDataToFreeToSpend(request: any) {
  return { ...(request.toJS ? request.toJS() : request) };
}
